var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      !_vm.showNotAvailableStemdoers
        ? _c(
            "v-container",
            { staticClass: "pa-0" },
            _vm._l(_vm.stemdoerRates, function (stemdoerRate) {
              return _c(
                "v-row",
                { key: stemdoerRate.stemdoer?.id, attrs: { "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "pa-0 mb-4" },
                    [
                      _c("SCardStemdoer", {
                        attrs: {
                          stemdoer: stemdoerRate.stemdoer,
                          rate: stemdoerRate.rate,
                          cardOptions: _vm.cardOptions,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showNotAvailableStemdoers
        ? _c(
            "v-container",
            { staticClass: "pa-0" },
            [
              _vm._l(_vm.availablesStemdoerRates, function (stemdoerRate) {
                return _c(
                  "v-row",
                  {
                    key: stemdoerRate.stemdoer?.id,
                    attrs: { "no-gutters": "" },
                  },
                  [
                    _c(
                      "v-col",
                      { staticClass: "pa-0 mb-4" },
                      [
                        _c("SCardStemdoer", {
                          attrs: {
                            stemdoer: stemdoerRate.stemdoer,
                            rate: stemdoerRate.rate,
                            cardOptions: _vm.cardOptions,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm.areStemdoersUnavailable
                ? _c(
                    "v-row",
                    { staticClass: "mt-2", attrs: { "no-gutters": "" } },
                    [
                      _c("v-col", { staticClass: "pa-0 mb-4" }, [
                        _c("span", {
                          staticClass: "text-body-1-bold text--text text--base",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t(
                                "teamRequestDetail.stemdoerList.notAvailables"
                              )
                            ),
                          },
                        }),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.notAvailablesStemdoerRates, function (stemdoerRate) {
                return _c(
                  "v-row",
                  {
                    key: stemdoerRate.stemdoer?.id,
                    attrs: { "no-gutters": "" },
                  },
                  [
                    _c(
                      "v-col",
                      { staticClass: "pa-0 mb-4" },
                      [
                        _c("SCardStemdoer", {
                          attrs: {
                            stemdoer: stemdoerRate.stemdoer,
                            rate: stemdoerRate.rate,
                            cardOptions: _vm.disabledCardOptions,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("ModalStemdoerDetail", {
        attrs: {
          isOpen: _vm.isStemdoerDetailModalOpen,
          onClose: _vm.closeStemdoerDetailModal,
          stemdoer: _vm.selectedStemdoer,
          rate: _vm.selectedStemdoerRate,
          company: _vm.associatedCompany,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }